import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { redirectAfterSave } from 'src/store/actions/actionCreators';
import { useAppDispatch, useAppSelector } from 'src/store/reducers';
import { closeContinueOrLeaveMessageAndLeave, closeContinueOrLeaveMessage } from 'src/store/reducers/uiSlice';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

type Props = {
  cancelTimers?: () => void;
};
const ConfirmationLightboxLagre = ({ cancelTimers }: Props): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const showContinueOrLeaveMessage = useAppSelector(state => state.refero.ui.showContinueOrLeaveMessage);
  const onCloseLagreMessageAndLeave = (): void => {
    dispatch(closeContinueOrLeaveMessageAndLeave());
    dispatch(redirectAfterSave());
  };

  const onContinueOrLeave = (): void => {
    cancelTimers?.();
    dispatch(closeContinueOrLeaveMessage());
  };

  return showContinueOrLeaveMessage && resources ? (
    <Modal
      testId="confirmation-lightbox-lagre"
      title={resources.lagreSkjemaTittel}
      description={resources.lagreSkjemaDokumenterBody}
      primaryButtonText={resources.lagreSkjemaButtonFortsettUtfylling}
      secondaryButtonText={resources.lagreSkjemaButtonFortsettSenere}
      onSuccess={onContinueOrLeave}
      onClose={onCloseLagreMessageAndLeave}
    />
  ) : null;
};

export default ConfirmationLightboxLagre;
